import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=37556f1e&scoped=true&"
import script from "./ItemsList.vue?vue&type=script&lang=ts&"
export * from "./ItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=37556f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37556f1e",
  null
  
)

export default component.exports